import { useNavigate, useLocation, useSearchParams as useReactRouterSearchParams, useParams as useReactRouterParams } from 'react-router-dom';

export const useRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    push: (url) => navigate(url),
    replace: (url) => navigate(url, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
    pathname: location.pathname,
    query: Object.fromEntries(new URLSearchParams(location.search)),
    asPath: location.pathname + location.search,
  };
};

export const useParams = () => {
  return useReactRouterParams();
};

export const useSearchParams = () => {
  const [searchParams, setSearchParams] = useReactRouterSearchParams();

  const searchParamsObj = {
    get: (key) => searchParams.get(key),
    getAll: (key) => searchParams.getAll(key),
    has: (key) => searchParams.has(key),
    set: (key, value) => {
      setSearchParams(prev => {
        const newParams = new URLSearchParams(prev);
        newParams.set(key, value);
        return newParams;
      });
    },
    delete: (key) => {
      setSearchParams(prev => {
        const newParams = new URLSearchParams(prev);
        newParams.delete(key);
        return newParams;
      });
    },
    toString: () => searchParams.toString(),
  };

  return searchParamsObj;
};